import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { FinalStepWrapper } from "./FinalStepWrapper";
import classNames from "clsx";
import { Button } from "react-migration/components/DeprecatedButton";

type LetterErrorProps = {
  onBackClick: () => void;
  backButtonText?: string;
};

export const LetterError = ({ onBackClick, backButtonText }: LetterErrorProps) => {
  const { t } = useTranslation();
  return (
    <FinalStepWrapper>
      <div
        className={classNames(
          "flex",
          "w-20",
          "h-20",
          "border",
          "justify-center",
          "items-center",
          "rounded-full",
          "border-negative-700",
          "bg-negative-700",
          "drop-shadow-lg",
          "drop-shadow-background-content-subtle"
        )}
      >
        <i className={classNames("icon-lt-close-line", "text-6xl", "flex", "text-white")} />
      </div>
      <span className={classNames("my-4", "text-content", "font-semibold", "text-xl", "leading-7")}>
        {t("sites.letters.error.title")}
      </span>
      <div className={classNames("text-base", "w-[400px]", "text-center")}>
        <span className="text-text-base-secondary" data-testid="extended-error-message">
          {t("sites.letters.error.message")}
        </span>
        <a href="mailto: support@land.tech?subject=Letter Sending" target="_blank" rel="noreferrer">
          {t("sites.letters.customer_support")}
        </a>
      </div>
      <Button.Primary className="mt-4" onClick={onBackClick}>
        {backButtonText ?? t("sites.letters.back_to_site")}
      </Button.Primary>
    </FinalStepWrapper>
  );
};
